import { faFileAlt, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useDispatch, useSelector } from "react-redux";
import {
  acceptOrRejectPatient,
  getPatients,
  setSelctedPatientFromPatinetList,
} from "../../actions/patientAction";
import {
  setActivePatientForProfile,
  setActivePatientName,
} from "../../actions/roleAction";
import Avatar from "../../assets/images/default-avatar.jpg";
import Loader from "../../components/Loader";
import history from "../../utils/history";
import NotePopup from "./NotePopup";
import { BUCKET_NAME } from "../../constants/states";
const PatientList = () => {
  const patientList = useSelector((state) => state.patient.patientList);
  const [filteredList, setFilteredList] = useState([]);
  const [showNotePopup, setShowNotePopup] = useState(false);
  const [activeNoteID, setActiveNoteId] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getPatients(() => {
        setIsLoading(false);
      })
    );
  }, [dispatch]);

  useEffect(() => {
    setFilteredList(patientList);
  }, [patientList]);

  const handleToggleActive = (id, active) => {
    let actionName = active
      ? "practitionerDeactivatesPatient"
      : "practitionerActivatesPatient";
    dispatch(
      acceptOrRejectPatient(actionName, id, () => {
        dispatch(getPatients());
      })
    );
  };

  const handleChange = (e) => {
    let searchTerm = e.target.value;

    let newList = patientList.filter(
      (x) =>
        x.First_Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        x.Last_Name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        x.nickname?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        x.Email?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredList(newList);
  };

  const setActiveNote = (id) => {
    setActiveNoteId(id);
    setShowNotePopup(true);
  };

  const patientAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div className="action-btn-wrapper row">
          <button
            className="btn-orange btn-table "
            onClick={() => {
              dispatch(setActivePatientForProfile(row.ID));
              dispatch(
                setActivePatientName(`${row.First_Name} ${row.Last_Name}`)
              );
              history.push("/app/prescription");
            }}
          >
            Create
          </button>

          <button
            className=" btn-orange btn-black  btn-table "
            onClick={() => {
              dispatch(
                setSelctedPatientFromPatinetList(
                  `${row.First_Name} ${row.Last_Name}`
                )
              );
              history.push("/app/prescriptions");
            }}
          >
            View
          </button>
        </div>
      </>
    );
  };

  const profileAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <button
        className="profile-icon"
        onClick={() => {
          history.push("/app/patient/info", row.ID);
        }}
      >
        <img
          src={
            row.Has_Profile_Picture
              ? `https://storage.googleapis.com/${BUCKET_NAME}/user/${
                  row.user_id
                }.png?${Math.random()}`
              : Avatar
          }
          alt="icon"
        />{" "}
        <span>View</span>
      </button>
    );
  };

  const columns = [
    {
      dataField: "ID",
      text: "Profile",
      sort: false,
      headerStyle: {
        width: "100px",
      },
      formatter: profileAction,
    },
    {
      dataField: "First_Name",
      text: "First Name",
      sort: true,
    },
    {
      dataField: "Last_Name",
      text: "Last Name",
      sort: true,
    },
    {
      dataField: "nickname",
      text: "Id / nickname",
      sort: true,
    },
    {
      dataField: "Email",
      text: "Email",
      sort: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <div className="d-flex justify-content-center">
              <p
                style={{
                  margin: 0,
                  wordWrap: "break-word",
                  overflow: "hidden",
                }}
              >
                {row.Email}
              </p>
            </div>
          </>
        );
      },
    },
    {
      dataField: "note",
      text: "notes",
      headerStyle: {
        width: "100px",
      },
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <FontAwesomeIcon
            icon={faFileAlt}
            size="3x"
            onClick={() => setActiveNote(row.ID)}
          />
        );
      },
    },
    {
      dataField: "active",
      text: "Active",
      sort: true,
      headerStyle: {
        width: "100px",
      },
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <div style={{ marginTop: "-20px" }}>
              <label className="container-check">
                <input
                  type="checkbox"
                  onChange={() => handleToggleActive(row.ID, row.active)}
                  defaultChecked={row.active}
                />
                <span className="checkmark-check"></span>
              </label>
            </div>
          </>
        );
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatter: patientAction,
    },
  ];

  return (
    <div>
      {isLoading && <Loader />}
      {showNotePopup && (
        <NotePopup
          patientId={activeNoteID}
          noteList={filteredList.find((x) => x.ID === activeNoteID).notes}
          closePopup={() => setShowNotePopup(false)}
        />
      )}
      <h5 className="profile-title">My Patients</h5>
      {patientList.length > 0 ? (
        <>
          <div className="row mt-1">
            <div className="col-md-6">
              <div className="form-group search">
                <div>
                  <label htmlFor="search">
                    Search: (FIRSTNAME, LASTNAME, ID/NICKNAME, EMAIL)
                  </label>
                  <div className="input">
                    <input
                      name="search"
                      className="form-control"
                      id="search"
                      onChange={handleChange}
                      type="text"
                    ></input>
                  </div>
                </div>
                <FontAwesomeIcon icon={faSearch} size="lg" color="gray" />
              </div>
            </div>
          </div>
          <BootstrapTable
            classes="react-bootstrap-table"
            keyField="ID"
            maxHeight="300px"
            columns={columns}
            data={filteredList}
            headerClasses="header-class"
          />
        </>
      ) : (
        <p className="page-desc">There are no patients at this time</p>
      )}
    </div>
  );
};

export default PatientList;
